import React from 'react';
import { PortfolioDetailsItem } from '../../../../models/Portfolio';
import { Box, ITheme, SvgIcon, Typography, useTheme } from '@mui/material';
import {ReactComponent as swapIcon} from '../../../../assets/swap_light.svg'
import {ReactComponent as moneyIcon} from '../../../../assets/money_light.svg'
import {ReactComponent as propIcon} from '../../../../assets/prop_light.svg'
import {ReactComponent as graphIcon} from '../../../../assets/graph_light.svg'
import {ReactComponent as stackIcon} from '../../../../assets/stack_light.svg'
import {ReactComponent as stockIcon} from '../../../../assets/stock_light.svg'
import { useTranslation } from 'react-i18next';

export interface IPerformanceMetricsProps{
    portfolio: PortfolioDetailsItem;
}

const PerformanceMetrics: React.FC<IPerformanceMetricsProps> = ({ portfolio }) => {
    const theme = useTheme() as ITheme;
    const { t, i18n } = useTranslation();

    const renderItem = (name: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string | undefined;}>, content: string, size: number): React.ReactNode => {
        return <Box display={"flex"} gap={"15px"} alignItems={"center"} flexBasis={"10px"} flexGrow={size}>
            <Box display={"flex"} width={"40px"} height={"40px"} justifyContent={"center"} alignItems={"center"}>
                <SvgIcon component={icon} inheritViewBox  sx={{ width: "100%", height: "100%"}} style={{ color: theme.palette.primary.dark }} />
            </Box>
            <Box display={"flex"} flexDirection={"column"}>
                <Typography fontSize={"16px"} fontWeight={"400"} lineHeight={"19.5px"}>{name}</Typography>
                <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24.38px"}>{content}</Typography>
            </Box>
        </Box>
    }

    return <Box display={"flex"} flexDirection={"column"} width={"100%"}>
        <Box display={"flex"} borderBottom={`1px solid ${theme.palette.primary.main}`} padding={"20px 10px"} gap={"15px"}>
            {renderItem(t('PortfolioPageItemCarryFee'), graphIcon, `${(portfolio.carryFee * 100).toFixed(1)}%`, 1.1)}
            {renderItem(t('PortfolioDetailsRevenueManagement'), stockIcon, `€${portfolio.revenueManagment.toLocaleString(i18n.language)}`, 1.5)}
        </Box>
        <Box display={"flex"} borderBottom={`1px solid ${theme.palette.primary.main}`} padding={"20px 10px"} gap={"15px"}>
            {renderItem(t('PortfolioPageItemMOIC'), swapIcon, portfolio.moic.toFixed(1), 1.1)}
            {renderItem(t('PortfolioPageItemIRR'), propIcon, `${Math.floor(portfolio.irr * 100)}%`, 1.5)}
        </Box>
        <Box display={"flex"} padding={"20px 10px"} gap={"15px"}>
            {renderItem(t('PortfolioPageItemDPI'), moneyIcon, portfolio.dpi.toFixed(1), 1.1)}
            {renderItem(t('PortfolioPageItemTVPI'), stackIcon, `${portfolio.tvpi.toFixed(1)}`, 1.5)}
        </Box>
    </Box>;
}

export default PerformanceMetrics;